import Vue from 'vue'
import Vuetify from 'vuetify'
// import 'vuetify/dist/vuetify.min.css'
import './vuetify.css'

Vue.use(Vuetify)
const opts = {
	theme: {
    options: { customProperties: true },//add this

  	disable: true,
    themes: {
      light: {
      	primary: '#54545b',
        green: '#54545b'
      }
    }
  }
}

export default new Vuetify(opts)
